

export function classCombine(classes: {[className: string]: boolean}): string {
    return Object.keys(classes).filter(className => classes[className]).join(' ');
}